// removed by extract-text-webpack-plugin
module.exports = {"spin":"src-display-modules-Home-Workbench2-UI-AppLoading-index__spin--1MgXi","opacityt-1":"src-display-modules-Home-Workbench2-UI-AppLoading-index__opacityt-1--2YwXp","opacityt-2":"src-display-modules-Home-Workbench2-UI-AppLoading-index__opacityt-2--1YH6O","opacityt-3":"src-display-modules-Home-Workbench2-UI-AppLoading-index__opacityt-3--2EBm-"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.AppLoading/index.scss
// module id = 6672
// module chunks = 0